/* global gdAlertify */
import React, { useState, useEffect } from "react";
import axiosInstance from "../config/axiosConfig";

const BitacoraPacienteModal = ({ pacienteId, onClose }) => {
    const [pacienteInfo, setPacienteInfo] = useState(null);
    const [visitas, setVisitas] = useState([]);
    const [detalleVisita, setDetalleVisita] = useState(null);
    
    // Obtener información del paciente y sus visitas al cargar el componente
    useEffect(() => {
        const cargarDatosPaciente = async () => {
            try {
                // Obtener información del paciente
                const infoPaciente = await axiosInstance.get("/paciente/busqueda",{
                    params: { id: pacienteId }
                });
                setPacienteInfo(infoPaciente.data.data[0]);
                
                // Obtener visitas del paciente
                const solicitudes = await axiosInstance.post("/paciente/visitas", {
                    pacienteID: pacienteId
                });
                setVisitas(solicitudes.data.data);
            } catch (error) {
                console.error("Error al obtener los datos: ", error);
                gdAlertify.notify('Error al cargar los datos del paciente', 'error');
            }
        };
        
        if (pacienteId) {
            cargarDatosPaciente();
        }
    }, [pacienteId]);

    const verVisita = (visitaID) => {
        const visitaDetalle = visitas.visitas.find(visita => visita.visitaID === visitaID);
        setDetalleVisita(visitaDetalle);
    };

    const verEnfermeria = (visitaID) => {
        const visitaDetalle = visitas.visitas.find(visita => visita.visitaID === visitaID);
        setDetalleVisita(visitaDetalle);
    };

    const renderDetalle = (titulo, valor) => {
        if (valor === null || valor === undefined) return null;
        return (
            <div key={titulo} className="mb-3 col-6">
                <h5>{titulo}</h5>
                <p>{valor}</p>
            </div>
        );
    };

    const eliminarVisita = (visitaID, tipo) => {
        gdAlertify.confirm({
            title: 'Eliminar visita',
            message: '¿Está seguro de que desea eliminar esta visita?',
            onConfirm: async () => {
                try {
                    const response = await axiosInstance.post('paciente/eliminar-visita', { 
                        visitaId: visitaID, 
                        tipo: tipo 
                    });

                    if (!response.data.error) {
                        gdAlertify.notify('Visita eliminada correctamente', 'success');
                        setDetalleVisita(null);
                        // Actualizar la lista de visitas
                        const updatedVisitas = await axiosInstance.post("/paciente/visitas", {
                            pacienteID: pacienteId
                        });
                        setVisitas(updatedVisitas.data.data);
                    } else {
                        gdAlertify.notify(response.data.message || 'Error al eliminar la visita', 'error');
                    }
                } catch (error) {
                    gdAlertify.notify('Error al eliminar la visita', 'error');
                }
            },
            onCancel: () => {
                gdAlertify.notify('Acción cancelada', 'info');
            }
        });
    };

    // Obtener ID del usuario actual desde el token
    const authToken = localStorage.getItem('authToken');
    const decodeJWT = (token) => {
        try {
            const base64Url = token.split('.')[1];
            const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            const jsonPayload = decodeURIComponent(
                atob(base64)
                    .split('')
                    .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                    .join('')
            );
            return JSON.parse(jsonPayload);
        } catch (error) {
            return null;
        }
    };
    const decodedToken = authToken ? decodeJWT(authToken) : null;
    const usuarioActualID = decodedToken?.id;

    return (
        <div className="modal-dialog modal-xl">
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title">
                        Bitácora de Paciente: {pacienteInfo 
                            ? `${pacienteInfo.nombres} ${pacienteInfo.apellidoPaterno} ${pacienteInfo.apellidoMaterno}`
                            : 'Cargando...'}
                    </h5>
                    <button type="button" className="btn-close" onClick={onClose}></button>
                </div>
                
                <div className="modal-body">
                    {visitas.indicadores && (
                        <div className="row mb-4">
                            <div className="col-md-4">
                                <div className="card">
                                    <div className="card-body">
                                        <h6 className="card-title">Total Visitas</h6>
                                        <p className="card-text fs-4">{visitas.indicadores.total_visitas}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="card">
                                    <div className="card-body">
                                        <h6 className="card-title">Visitas Presenciales</h6>
                                        <p className="card-text fs-4">{visitas.indicadores.visitas_presenciales}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="card">
                                    <div className="card-body">
                                        <h6 className="card-title">Visitas Telefónicas</h6>
                                        <p className="card-text fs-4">{visitas.indicadores.visitas_telefonicas}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    
                    <div className="row">
                        {/* Columna de botones de visitas */}
                        <div className="col-md-3">
                            <div className="card">
                                <div className="card-header">
                                    <h5>Historial de Visitas</h5>
                                </div>
                                <div className="card-body p-0">
                                    <div className="list-group list-group-flush">
                                        {visitas.visitas?.length > 0 ? (
                                            visitas.visitas.map((visita, index) => (
                                                <button
                                                    key={visita.visitaID}
                                                    className={`list-group-item list-group-item-action 
                                                        ${detalleVisita?.visitaID === visita.visitaID ? 'active' : ''}
                                                        ${visita.tipo_visita === 1 ? 'list-group-item-primary' : 'list-group-item-success'}`}
                                                    onClick={() => {
                                                        if (visita.tipo_visita === 1) {
                                                            verVisita(visita.visitaID);
                                                        } else {
                                                            verEnfermeria(visita.visitaID);
                                                        }
                                                    }}
                                                >
                                                    {visita.tipo_visita === 1 ? "Visita" : "Enfermería"} {index + 1}
                                                    <br />
                                                    <small>{new Date(visita.fecha_visita).toLocaleDateString()}</small>
                                                </button>
                                            ))
                                        ) : (
                                            <div className="list-group-item text-muted">
                                                No hay visitas registradas
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        {/* Columna de detalles */}
                        <div className="col-md-9">
                            <div className="card">
                                <div className="card-header d-flex justify-content-between align-items-center">
                                    <h5>
                                        {detalleVisita 
                                            ? `Detalle de ${detalleVisita.tipo_visita === 1 ? 'Visita' : 'Enfermería'}`
                                            : 'Seleccione una visita'}
                                    </h5>
                                    {/* {detalleVisita && detalleVisita.usuario_id == usuarioActualID && (
                                        <button
                                            className="btn btn-danger btn-sm"
                                            onClick={() => eliminarVisita(detalleVisita.visitaID, detalleVisita.tipo_visita)}
                                        >
                                            Eliminar {detalleVisita.tipo_visita === 1 ? "Visita" : "Enfermería"}
                                        </button>
                                    )} */}
                                </div>
                                
                                <div className="card-body">
                                    {detalleVisita ? (
                                        <div className="row">
                                            {detalleVisita.tipo_visita === 1 ? (
                                                <>
                                                    {renderDetalle('Enfermero/a Visita', detalleVisita.usuario_visita)}
                                                    {renderDetalle('Fecha de la Visita', detalleVisita.fecha_visita)}
                                                    {renderDetalle('Tipo de Visita', 'Presencial')}
                                                    {renderDetalle('Antecedentes Médicos', detalleVisita.antecedentes_medicos)}
                                                    {renderDetalle('Diagnóstico', detalleVisita.diagnostico)}
                                                    {renderDetalle('Estado Cognitivo', detalleVisita.estado_cognitivo)}
                                                    {renderDetalle('Estado de Salud', detalleVisita.estado_salud)}
                                                    {renderDetalle('Evolución', detalleVisita.examen_fisico)}
                                                    {renderDetalle('Habla', detalleVisita.habla)}
                                                    {renderDetalle('Medicamentos y Horarios', detalleVisita.medicamento_horarios)}
                                                    {renderDetalle('Movimiento', detalleVisita.movimiento)}
                                                    {renderDetalle('Observación', detalleVisita.observacion)}
                                                    {renderDetalle('Plan de Atención', detalleVisita.plan_atencion)}
                                                    {renderDetalle('Rutina', detalleVisita.rutina)}
                                                </>
                                            ) : (
                                                <>
                                                    {renderDetalle('Enfermero/a Visita', detalleVisita.nombre + ' ' + detalleVisita.apellido)}
                                                    {renderDetalle('Nombre Paciente', detalleVisita.nombre_paciente)}
                                                    {renderDetalle('Fecha de Registro', detalleVisita.fechaRegistro)}
                                                    {renderDetalle('Estado de Cama', detalleVisita.estadoCama)}
                                                    {renderDetalle('Estado de Casa', detalleVisita.estadoCasa)}
                                                    {renderDetalle('Estado Cognitivo', detalleVisita.estadoCognitivo)}
                                                    {renderDetalle('Estado de Salud', detalleVisita.estadoSalud)}
                                                    {renderDetalle('Estado de Habitación', detalleVisita.estadoHabitacion)}
                                                    {renderDetalle('Evaluación Domicilio', detalleVisita.evaluacionDomicilio)}
                                                    {renderDetalle('Evolución', detalleVisita.examenFisico)}
                                                    {renderDetalle('Asistencia Adicional', detalleVisita.asistenciaAdicional)}
                                                    {renderDetalle('Lenguaje', detalleVisita.capacidadHablar)}
                                                    {renderDetalle('Movilidad', detalleVisita.capacidadMoverse)}
                                                    {renderDetalle('Medicamentos', detalleVisita.medicamentos)}
                                                    {renderDetalle('Necesidades Especiales', detalleVisita.necesidadesEspeciales)}
                                                    {renderDetalle('Plan de Atención', detalleVisita.planAtencion)}
                                                    {renderDetalle('Riesgos', detalleVisita.riesgos)}
                                                    {renderDetalle('Rutinas', detalleVisita.rutinas)}
                                                </>
                                            )}

                                            {detalleVisita.observaciones_auxiliar?.length > 0 && (
                                                <div className="col-12 mt-4">
                                                    <h5>Observaciones Auxiliar</h5>
                                                    <div className="table-responsive">
                                                        <table className="table table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <th>Nombre Auxiliar</th>
                                                                    <th>Observación</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {detalleVisita.observaciones_auxiliar.map((observacion, index) => (
                                                                    <tr key={index}>
                                                                        <td>{observacion.nombre_auxiliar}</td>
                                                                        <td>{observacion.observacion}</td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    ) : (
                                        <div className="text-center text-muted py-4">
                                            <i className="bi bi-info-circle fs-1"></i>
                                            <p className="mt-2">Seleccione una visita para ver los detalles</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" onClick={onClose}>
                        Cerrar
                    </button>
                </div>
            </div>
        </div>
    );
};

export default BitacoraPacienteModal;